import { mapState, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import ServiceScreenSelectorButton from '@/components/Ui/ServiceScreenSelectorButton'
import ApiManager from '@/utils/ApiManager'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'

export default {
  name: 'ServiceFunctionDetailKeikai',
  components: {
    Loading,
    FileSelectorButton,
    ServiceScreenSelectorButton
  },
  data () {
    return {
      loading: true,
      processing: false,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceFunctionDetail.categoryName,
      functionName: state => state.serviceFunctionDetail.functionName,

      // form
      serviceUuid: state => state.serviceFunctionDetail.serviceId,
      serviceFunctionUuid: state => state.serviceFunctionDetail.targetId,
      values: state => state.serviceFunctionDetail.values,
      deliveryType: state => state.serviceFunctionDetail.deliveryType,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // input
    inpKeikaiJingleFile: {
      get () {
        return this.values.inpKeikaiJingleFile
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiJingleFile',
          value: value
        })
      }
    },
    inpKeikaiSoundFile: {
      get () {
        return this.values.inpKeikaiSoundFile
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiSoundFile',
          value: value
        })
      }
    },
    inpKeikaiLevel0TextMain: {
      get () {
        return this.values.inpKeikaiLevel0TextMain
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel0TextMain',
          value: value
        })
      }
    },
    inpKeikaiLevel0TextSub: {
      get () {
        return this.values.inpKeikaiLevel0TextSub
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel0TextSub',
          value: value
        })
      }
    },
    inpKeikaiLevel1TextMain: {
      get () {
        return this.values.inpKeikaiLevel1TextMain
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel1TextMain',
          value: value
        })
      }
    },
    inpKeikaiLevel1TextSub: {
      get () {
        return this.values.inpKeikaiLevel1TextSub
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel1TextSub',
          value: value
        })
      }
    },
    inpKeikaiLevel2TextMain: {
      get () {
        return this.values.inpKeikaiLevel2TextMain
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel2TextMain',
          value: value
        })
      }
    },
    inpKeikaiLevel2TextSub: {
      get () {
        return this.values.inpKeikaiLevel2TextSub
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel2TextSub',
          value: value
        })
      }
    },
    inpKeikaiLevel3TextMain: {
      get () {
        return this.values.inpKeikaiLevel3TextMain
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel3TextMain',
          value: value
        })
      }
    },
    inpKeikaiLevel3TextSub: {
      get () {
        return this.values.inpKeikaiLevel3TextSub
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel3TextSub',
          value: value
        })
      }
    },
    inpKeikaiLevel4TextMain: {
      get () {
        return this.values.inpKeikaiLevel4TextMain
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel4TextMain',
          value: value
        })
      }
    },
    inpKeikaiLevel4TextSub: {
      get () {
        return this.values.inpKeikaiLevel4TextSub
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel4TextSub',
          value: value
        })
      }
    },
    inpKeikaiLevel5TextMain: {
      get () {
        return this.values.inpKeikaiLevel5TextMain
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel5TextMain',
          value: value
        })
      }
    },
    inpKeikaiLevel5TextSub: {
      get () {
        return this.values.inpKeikaiLevel5TextSub
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeikaiLevel5TextSub',
          value: value
        })
      }
    },
    inpNoteText: {
      get () {
        return this.values.inpNoteText
      },
      set (value) {
        this.setInputValue({
          key: 'inpNoteText',
          value: value
        })
      }
    },
    inpOkBtnActionParameterIsValid () {
      //TODO ActionTypeごとにバリデート
      return true
    },
    formIsValid () {
      return this.inpOkBtnActionParameterIsValid
    },
    disableConfirmButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
    }),
    ...mapMutations({
      setInputValue: 'serviceFunctionDetail/setInputValue',
    }),

    init () {
      // input
      this.loading = false
    },
    turnBack () {
      this.$router.push({
        name: 'ServiceFunction',
        params: {
          serviceId: this.serviceUuid
        }
      })
    },

    postData () {
      this.processing = true

      // jsonb : FunctionKeikai(警戒レベル告知機能)
      let jsonb = {}
      // ジングル音
      if (this.inpKeikaiJingleFile) {
        jsonb.keikaiJingleFile = Jsonb.requestFile(this.values.keikaiJingleFile, this.inpKeikaiJingleFile)
      }
      // 音声メッセージ
      if (this.inpKeikaiSoundFile) {
        jsonb.keikaiSoundFile = Jsonb.requestFile(this.values.keikaiSoundFile, this.inpKeikaiSoundFile)
      }
      // レベル別テキスト設定
      if (this.inpKeikaiLevel0TextMain) {
        jsonb.keikaiLevel0TextMain = this.inpKeikaiLevel0TextMain
      }
      if (this.inpKeikaiLevel0TextSub) {
        jsonb.keikaiLevel0TextSub = this.inpKeikaiLevel0TextSub
      }
      if (this.inpKeikaiLevel1TextMain) {
        jsonb.keikaiLevel1TextMain = this.inpKeikaiLevel1TextMain
      }
      if (this.inpKeikaiLevel1TextSub) {
        jsonb.keikaiLevel1TextSub = this.inpKeikaiLevel1TextSub
      }
      if (this.inpKeikaiLevel2TextMain) {
        jsonb.keikaiLevel2TextMain = this.inpKeikaiLevel2TextMain
      }
      if (this.inpKeikaiLevel2TextSub) {
        jsonb.keikaiLevel2TextSub = this.inpKeikaiLevel2TextSub
      }
      if (this.inpKeikaiLevel3TextMain) {
        jsonb.keikaiLevel3TextMain = this.inpKeikaiLevel3TextMain
      }
      if (this.inpKeikaiLevel3TextSub) {
        jsonb.keikaiLevel3TextSub = this.inpKeikaiLevel3TextSub
      }
      if (this.inpKeikaiLevel4TextMain) {
        jsonb.keikaiLevel4TextMain = this.inpKeikaiLevel4TextMain
      }
      if (this.inpKeikaiLevel4TextSub) {
        jsonb.keikaiLevel4TextSub = this.inpKeikaiLevel4TextSub
      }
      if (this.inpKeikaiLevel5TextMain) {
        jsonb.keikaiLevel5TextMain = this.inpKeikaiLevel5TextMain
      }
      if (this.inpKeikaiLevel5TextSub) {
        jsonb.keikaiLevel5TextSub = this.inpKeikaiLevel5TextSub
      }
      // 注意書きテキスト設定
      if (this.inpNoteText) {
        jsonb.noteText = this.inpNoteText
      }

      // リクエストパラメータ
      let parameters = {
        serviceUuid: this.serviceUuid,
        serviceFunctionUuid: this.serviceFunctionUuid,
        request: {
          keikaiSetting: jsonb
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.functionName + '情報の登録',
              body: this.functionName + '情報を登録しました。',
            })

            // 一覧へリダイレクト
            this.turnBack()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    confirmData () {
      // validate
      if (this.formIsValid) {
        // confirm
        this.showConfirm({
          key: 'register',
          title: '',
          body: 'この' + this.functionName + '情報を登録しますか？'
        })
      }
    },

    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      console.log('changeFileFromSelector', props)
      this.setInputValue({
        key: props.name,
        value: Jsonb.formatFile(props.data)
      })
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      console.log('deleteFileFromSelector', props)
      this.setInputValue({
        key: props.name,
        value: null
      })
    },
  }
}